
import { useMemo } from "react"
import { Stack, TablePagination } from "@mui/material"
import { GridRowSelectionModel } from "@mui/x-data-grid"
import { PgtoStyledDataGrid } from "./pgto_data_grid"
import { GeneratePgtoContratosColumns } from "../columns"
import { ModelPgtoContratoFinanceiroLista } from "../../../../domain/models/pgto_contrato_financeiro_lista"
import { ValoresContratoFinanceiro } from "../../../../domain/models/valoresContratoFinanceiro"

type Props = {
    loading: boolean,
    pgtoContratoLista: ModelPgtoContratoFinanceiroLista[] | [],
    page: number,
    rowsPerPage: number,
    totalItems: number,
    rowSelectionModel: GridRowSelectionModel | undefined,
    valoresFooter: ValoresContratoFinanceiro | undefined,
    handlePgtoCadastroOpenState: (idPgto: number | null, openState: boolean) => void,
    handlePgtoDeleteOpenState: (idPgto: number | null, openState: boolean) => void,

    handleRowSelectionModelChange: (rows: GridRowSelectionModel) => void,
    handlePageChange: (page: number) => void,
    handleRowsPerPageChange: (rowsPerPage: number) => void,
}

export const TabelaPgtoContrato = ({
    loading,
    pgtoContratoLista,
    page,
    rowsPerPage,
    rowSelectionModel,
    totalItems,
    valoresFooter,

    handlePgtoDeleteOpenState,
    handlePgtoCadastroOpenState,
    handleRowSelectionModelChange,
    handlePageChange,
    handleRowsPerPageChange,

}: Props) => {

    const columnsDef = useMemo(() => {
        return GeneratePgtoContratosColumns({
            onActionDelete: handlePgtoDeleteOpenState,
            onActionEdit: handlePgtoCadastroOpenState,

        });
    }, [
        handlePgtoDeleteOpenState,
        handlePgtoCadastroOpenState,
    ]);

    return (
        <>

            <Stack spacing={0}>
                <div className="w-full flex flex-row justify-between items-stretch">
                    <div className="flex flex-col justify-between flex-1">
                        <TablePagination
                            component="div"
                            count={totalItems}
                            page={page - 1}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            onPageChange={(_, p) => handlePageChange(p)}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(e) => handleRowsPerPageChange(parseInt(e.target.value))} />
                    </div>
                </div>

                <PgtoStyledDataGrid
                    tableName="pgto_contrato_lista"
                    disableColumnMenu={false}
                    getRowId={(row: ModelPgtoContratoFinanceiroLista) => row.idPgtoContratoFinanceiro}
                    columns={columnsDef}
                    loading={loading}
                    rows={pgtoContratoLista}
                    rowCount={pgtoContratoLista.length}
                    checkboxSelection={true}
                    disableRowSelectionOnClick={true}
                    onRowSelectionModelChange={handleRowSelectionModelChange}
                    rowSelectionModel={rowSelectionModel}
                    pageSizeOptions={[10, 25, 50, 100]}
                    valoresContratoFinanceiro={valoresFooter}
                    paginationMode="server"
                    paginationModel={{
                        page: page - 1,
                        pageSize: rowsPerPage,
                    }} pinnedColumns={{
                        left: ["__check__"],
                        right: ['idPgtoContratoFinanceiro'],

                    }}
                    getRowHeight={() => 'auto'}


                />

                <TablePagination
                    component="div"
                    count={totalItems}
                    page={page - 1}
                    onPageChange={(_, p) => handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={rowsPerPage > 0 ? rowsPerPage : 25}
                    onRowsPerPageChange={(e) => handleRowsPerPageChange(parseInt(e.target.value))}
                />

            </Stack>

        </>
    )
}